"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chevronDown = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M11.9999 17.0605 3.9992 9.0593l1.4142-1.4141L12 14.2322l6.5869-6.586 1.4141 1.4143-8.0011 8z" } }];
exports.iconName = 'chevron-down';
exports.chevronDown = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
